module.exports = __webpack_public_path__ + "img/3.7f52cbfd.jpg";